import { useCallback, useState } from 'react';

export interface UseDocumentCardsControllerOptions {
	ids: string[];
}
export const useDocumentCardsController = ({ ids }: UseDocumentCardsControllerOptions) => {
	const [selectedActiveDocumentId, setSelectedActiveDocumentId] = useState('');
	const [activeCheckboxesIds, setActiveCheckboxesIds] = useState<string[]>([]);
	const [documents, setDocuments] = useState(ids);
	const [openedDropdownDocumentCardId, setOpenedDropdownDocumentCardId] = useState<string>();

	const toggleCheckboxState = useCallback((id: string) => {
		setActiveCheckboxesIds((prevState) => {
			const newActiveCheckboxes = [...prevState];
			const index = newActiveCheckboxes.indexOf(id);
			if (index >= 0) {
				newActiveCheckboxes.splice(index, 1);
			} else {
				newActiveCheckboxes.push(id);
			}
			return newActiveCheckboxes;
		});
	}, []);

	const onClickDropdown = (id: string) => setOpenedDropdownDocumentCardId(id);

	const onCloseDropdown = () => setOpenedDropdownDocumentCardId(undefined);

	return {
		documents,
		setDocuments,
		selectedActiveDocumentId,
		setSelectedActiveDocumentId,
		toggleCheckboxState,
		activeCheckboxesIds,
		onClickDropdown,
		openedDropdownDocumentCardId,
		onCloseDropdown,
	};
};
